var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 0.5,
    width: 56,
    height: 56,
    rx: 4,
    fill: "#288F58",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.1665,
    y: 1,
    width: 55,
    height: 55,
    rx: 3.5,
    stroke: "#288F58",
    strokeOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_21702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.126 29.3141C37.65 29.3141 39.8214 27.0604 39.8214 24.1256C39.8214 21.2261 37.6385 19.0781 35.126 19.0781C32.614 19.0781 30.4305 21.273 30.4305 24.149C30.4305 27.0604 32.602 29.3141 35.126 29.3141ZM21.6145 29.5844C23.798 29.5844 25.7003 27.6118 25.7003 25.0644C25.7003 22.541 23.786 20.6741 21.6145 20.6741C19.4317 20.6741 17.506 22.5878 17.518 25.0884C17.518 27.6118 19.4197 29.5844 21.6151 29.5844M15.0648 40.1844H23.986C22.7654 38.4118 24.2563 34.8433 26.7803 32.8947C25.4774 32.0261 23.798 31.3804 21.6031 31.3804C16.3088 31.3798 12.9985 35.2884 12.9985 38.5404C12.9985 39.5976 13.5854 40.1844 15.0648 40.1844ZM27.7425 40.1844H42.498C44.3408 40.1844 44.9985 39.6558 44.9985 38.6227C44.9985 35.5941 41.2065 31.4153 35.1145 31.4153C29.034 31.4153 25.242 35.5941 25.242 38.6233C25.242 39.6558 25.8991 40.1844 27.7425 40.1844Z",
    fill: "#288F58"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_21702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12.9985 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondTitleIcon);
export default __webpack_public_path__ + "static/media/second-title-icon.93dcbf4c7fc0ea92c28b99295d753ef1.svg";
export { ForwardRef as ReactComponent };